<template>
  <div class="onboarding_page">
    <h2>Ange vilka krav ni har på era medlemmar</h2>
    <p>Vilka fält är det som medlemmarna måste fylla i om sig själva för att kunna bli giltig medlem hos er?</p>
    
    <Requirements 

    />
    
    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>
    
  </div>
</template>

<script>
import Requirements from '@/view/pages/ml/settings/Requirements.vue';

export default {
  name: 'onboarding_page2',
  props: ['onboarding_data'],
  emits: ['next_page','prev_page','update_data'],
  components: {
    Requirements
  },
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
      },
      immediate: true
    },
  },
  data() {
    return {
      local_onboarding_data: null,
    }
  },
  methods: {
    next_page() {
      this.local_onboarding_data.membership_requirements_shown = true;
      this.local_onboarding_data.membership_requirements = this.requirements;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>
